// Single source of truth for shipping, delivery and returns facts.
// Every number here is verified against the store that actually fulfils and
// charges for the order (furnifindusa.com/policies/shipping-policy).
// Never state a shipping promise anywhere in the app without importing it here.

/** Order subtotal at or above which delivery is free. */
export const FREE_SHIPPING_THRESHOLD = 120;

/** Flat delivery charge applied below the threshold. */
export const FLAT_SHIPPING_RATE = 9.9;

// The copy lives in scripts/site-policy.mjs so the prerendered /faq, /shipping
// and /returns bodies state exactly the same terms.
export {
  FREE_SHIPPING_COPY,
  FREE_SHIPPING_SHORT,
  FREE_SHIPPING_OVER,
  FLAT_SHIPPING_COPY,
  DELIVERY_WINDOW_COPY,
  SHIPPING_REGION_COPY,
  RETURN_CONDITION_COPY,
  RETURNS_WINDOW_COPY,
  RETURN_SHIPPING_COPY,
} from "../../scripts/site-policy.mjs";

/** Delivery cost for a given order subtotal. */
export const shippingCostFor = (subtotal: number) =>
  subtotal >= FREE_SHIPPING_THRESHOLD ? 0 : FLAT_SHIPPING_RATE;
